import { ColliClient } from '@frontend/colli/api';
import { Colli } from '@frontend/colli/types';
import { PinCode } from '@frontend/pin-code/types';
import { TransactionUserClient } from '@frontend/transaction/api';
import { Transaction, TransactionUser } from '@frontend/transaction/types';
import { ScreenTrigger, ScreenType } from '@frontend/wizard/types';
import { useEffect, useState } from 'react';

import { useScreen } from '../useScreen';

interface ViewProps {
    transaction: Transaction | null;
    collis: Colli[] | null;
    receivers: TransactionUser[] | null;
    pin_code: PinCode | null;

    commentsVisible: boolean;
    setCommentsVisible: (visible: boolean) => void;
    submitDisabled: boolean;
    onSubmit: () => void;
    onBack: (screen: ScreenType) => void;
}

const usePickUpOverview = (): ViewProps => {
    const { store, onBack, onSubmit: onContinue, updateWizardData } = useScreen();
    const [commentsVisible, setCommentsVisible] = useState<boolean>(true);
    const [collis, setCollis] = useState<Colli[] | null>(store?.data.collis || null);
    const [receivers, setReceivers] = useState<TransactionUser[] | null>(store?.data.receivers || null);

    useEffect(() => {
        if (!collis && store?.data.transaction) ColliClient.fetchCollis({ transaction_id: store.data.transaction.id }).then((res) => setCollis(res.results));
    }, [collis, store?.data.transaction]);

    useEffect(() => {
        if (!receivers && store?.data.transaction)
            TransactionUserClient.fetchTransactionUsers({ transaction_id: store.data.transaction.id }).then((res) =>
                setReceivers(res.results.filter((u) => u.type === 'receiver'))
            );
        else if (store?.data.receiver) setReceivers([store.data.receiver]);
    }, [receivers, store?.data]);

    const onSubmit = async () => {
        updateWizardData({
            collis,
            receivers
        });
        const nextStep = store?.steps.find(
            (step) =>
                step.screen === ScreenType.PICK_UP_OVERVIEW &&
                [ScreenTrigger.SUBMIT_FALSE, ScreenTrigger.SUBMIT, ScreenTrigger.SUBMIT_TRUE].includes(step.trigger)
        );
        onContinue(nextStep);
    };

    return {
        transaction: store?.data.transaction || null,
        collis,
        receivers,
        commentsVisible,
        setCommentsVisible,
        submitDisabled: false,
        onSubmit,
        onBack,
        pin_code: store?.data.pin_code || null
    };
};

export default usePickUpOverview;
